(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tarjeta-producto"] && !Shopify.designMode) return;
  try {
    if (!window.__tarjetaProductoInicializada) {
    window.__tarjetaProductoInicializada = true;

    const leerVariantes = (tarjeta) => {
      const nodo = tarjeta.querySelector('[data-tarjeta-producto-variantes]');
      if (!nodo) return [];
      try {
        return JSON.parse(nodo.textContent || '[]');
      } catch (error) {
        return [];
      }
    };

    const resolverVariante = (variantes, seleccion) => {
      return variantes.find((variante) => {
        if (seleccion[1] && variante.option1 !== seleccion[1]) return false;
        if (seleccion[2] && variante.option2 !== seleccion[2]) return false;
        if (seleccion[3] && variante.option3 !== seleccion[3]) return false;
        return true;
      });
    };

    const seleccionDesdeTarjeta = (tarjeta) => {
      const seleccion = {};
      tarjeta.querySelectorAll('[data-tarjeta-producto-opcion][aria-pressed="true"]').forEach((opcion) => {
        seleccion[Number(opcion.dataset.posicion)] = opcion.dataset.valor;
      });
      return seleccion;
    };

    const varianteParaImagen = (variantes, seleccion) => {
      const posiciones = Object.keys(seleccion).filter((pos) => seleccion[pos]);
      if (!posiciones.length) return null;
      const coincidencias = variantes.filter((variante) =>
        posiciones.every((pos) => String(variante[`option${pos}`] ?? '') === String(seleccion[pos]))
      );
      if (!coincidencias.length) return null;
      return coincidencias.find((v) => v.available) || coincidencias[0];
    };

    const leerColorMedia = (tarjeta) => {
      const nodo = tarjeta.querySelector('[data-tarjeta-producto-color-media]');
      if (!nodo) return [];
      try {
        return JSON.parse(nodo.textContent || '[]');
      } catch (error) {
        return [];
      }
    };

    const urlImagenPorColor = (tarjeta, variante, seleccion) => {
      const mapa = leerColorMedia(tarjeta);
      if (!mapa.length) return '';
      const coincideColor = (fila) => {
        if (!fila?.color || !fila.url) return false;
        const pos = fila.posicion_opcion || 1;
        const valor = variante?.[`option${pos}`] ?? seleccion?.[pos] ?? seleccion?.[String(pos)];
        return valor != null && String(valor) === String(fila.color);
      };
      if (variante) {
        const filaVariante = mapa.find(coincideColor);
        if (filaVariante?.url) return filaVariante.url;
      }
      for (const [pos, val] of Object.entries(seleccion || {})) {
        const fila = mapa.find(
          (f) => f.url && String(f.posicion_opcion) === String(pos) && String(f.color) === String(val)
        );
        if (fila?.url) return fila.url;
      }
      return '';
    };

    const focalPorColor = (tarjeta, variante, seleccion) => {
      const mapa = leerColorMedia(tarjeta);
      if (!mapa.length) return 'center 20%';
      const pos = variante?.[`option${mapa[0]?.posicion_opcion}`];
      if (pos) {
        const fila = mapa.find((f) => f.focal && String(f.color) === String(pos));
        if (fila?.focal) return fila.focal;
      }
      for (const [p, val] of Object.entries(seleccion || {})) {
        const fila = mapa.find(
          (f) => f.focal && String(f.posicion_opcion) === String(p) && String(f.color) === String(val)
        );
        if (fila?.focal) return fila.focal;
      }
      return 'center 20%';
    };

    const urlImagenVariante = (variante, anchoPreferido, tarjeta, seleccion) => {
      const base =
        variante?.featured_image?.src ||
        (variante?.featured_media?.preview_image && variante.featured_media.preview_image.src) ||
        '';
      const porColor = tarjeta ? urlImagenPorColor(tarjeta, variante, seleccion) : '';
      const origen = base || porColor;
      if (!origen) return '';
      const ancho = anchoPreferido || 640;
      if (origen.includes('width=')) return origen;
      const separador = origen.includes('?') ? '&' : '?';
      return `${origen}${separador}width=${ancho}`;
    };

    const actualizarImagenTarjeta = (tarjeta, variante) => {
      const img = tarjeta.querySelector('.tarjeta-producto__imagen--principal');
      if (!img || !variante) return;
      const seleccion = seleccionDesdeTarjeta(tarjeta);
      const match = img.src && img.src.match(/[?&]width=(\d+)/);
      const nuevaUrl = urlImagenVariante(variante, match ? match[1] : null, tarjeta, seleccion);
      if (!nuevaUrl) return;
      const archivoNuevo = nuevaUrl.split('?')[0].split('/').pop();
      if (img.src.includes(archivoNuevo)) return;
      img.src = nuevaUrl;
      img.removeAttribute('srcset');
      img.style.objectPosition = focalPorColor(tarjeta, variante, seleccion);
      const mini = urlImagenVariante(variante, 240, tarjeta, seleccion);
      if (mini) {
        tarjeta.dataset.productoImagen = mini;
        tarjeta.querySelectorAll('[data-producto-imagen]').forEach((nodo) => {
          nodo.dataset.productoImagen = mini;
        });
      }
    };

    const sincronizarVistaVariante = (tarjeta) => {
      const variantes = leerVariantes(tarjeta);
      const seleccion = seleccionDesdeTarjeta(tarjeta);
      const variante = varianteParaImagen(variantes, seleccion);
      if (!variante) return;
      actualizarImagenTarjeta(tarjeta, variante);
      if (window.NaiaPrecio?.aplicarPrecioConCompare) {
        window.NaiaPrecio.aplicarPrecioConCompare(
          tarjeta.querySelector('[data-tarjeta-producto-precio]'),
          variante.price,
          variante.compare_at_price
        );
      }
      tarjeta.dispatchEvent(
        new CustomEvent('tarjeta-producto:variante-cambiada', {
          bubbles: true,
          detail: { variante, seleccion: { ...seleccion } },
        })
      );
    };

    const emitirCarritoActualizado = async (tarjeta, datosAdd) => {
      const urlCarrito = tarjeta.dataset.urlCarrito || '/cart.js';
      let carrito = null;
      try {
        carrito = await fetch(urlCarrito, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      } catch (error) {
        carrito = null;
      }
      const item = datosAdd.items?.[0];
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          detail: {
            cart: carrito,
            itemCount: carrito?.item_count ?? datosAdd.item_count,
            abrirDrawer: true,
            mostrarToast: true,
            producto: {
              titulo: item?.product_title || item?.title || tarjeta.dataset.productoTitulo || '',
              imagen: item?.image || tarjeta.dataset.productoImagen || '',
              url: item?.url || tarjeta.dataset.productoUrl || '',
            },
          },
        })
      );
    };

    const anadirVariante = async (tarjeta, varianteId, botonActivo) => {
      if (tarjeta.dataset.anadiendo === 'true') return;
      tarjeta.dataset.anadiendo = 'true';
      const idPeticion = String(Date.now()) + Math.random();
      tarjeta.dataset.peticionCarrito = idPeticion;

      const feedback = tarjeta.querySelector('[data-tarjeta-producto-feedback]');
      const url = tarjeta.dataset.urlAnadir;
      const urlCarrito = tarjeta.dataset.urlCarrito || '/cart.js';
      const textoAnadiendo = tarjeta.dataset.textoAnadiendo || 'Añadiendo…';
      const textoError = tarjeta.dataset.textoError || '';
      const textoErrorRed = tarjeta.dataset.textoErrorRed || textoError;
      const textoBoton = tarjeta.dataset.textoBotonAnadir || 'Añadir al carrito';
      const textoAgotado = tarjeta.dataset.textoAgotado || 'Agotado';

      if (feedback) {
        feedback.hidden = false;
        feedback.classList.remove('tarjeta-producto__feedback--error');
        feedback.textContent = textoAnadiendo;
      }

      if (botonActivo) {
        botonActivo.disabled = true;
        botonActivo.textContent = textoAnadiendo;
      }

      const controlador = new AbortController();
      const temporizador = window.setTimeout(() => controlador.abort(), 20000);

      try {
        const respuesta = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items: [{ id: Number(varianteId), quantity: 1 }] }),
          signal: controlador.signal,
        });
        const datos = await respuesta.json();
        if (tarjeta.dataset.peticionCarrito !== idPeticion) return;

        if (datos.status) {
          if (feedback) {
            feedback.classList.add('tarjeta-producto__feedback--error');
            feedback.textContent = datos.description || datos.message || textoError;
          }
        } else {
          const item = datos.items?.[0];
          if (item && String(item.variant_id) !== String(varianteId)) {
            if (feedback) {
              feedback.classList.add('tarjeta-producto__feedback--error');
              feedback.textContent = textoError;
            }
            return;
          }
          if (feedback) {
            feedback.hidden = true;
            feedback.textContent = '';
          }
          await emitirCarritoActualizado(tarjeta, datos);
        }
      } catch (error) {
        if (tarjeta.dataset.peticionCarrito !== idPeticion) return;
        try {
          const carrito = await fetch(urlCarrito, { headers: { Accept: 'application/json' } }).then((r) => r.json());
          const linea = carrito?.items?.find((i) => String(i.variant_id) === String(varianteId));
          if (linea) {
            if (feedback) {
              feedback.hidden = true;
              feedback.textContent = '';
            }
            await emitirCarritoActualizado(tarjeta, { items: [linea], item_count: carrito.item_count });
          } else if (feedback) {
            feedback.classList.add('tarjeta-producto__feedback--error');
            feedback.textContent = textoErrorRed;
          }
        } catch (e2) {
          if (feedback) {
            feedback.classList.add('tarjeta-producto__feedback--error');
            feedback.textContent = textoErrorRed;
          }
        }
      } finally {
        window.clearTimeout(temporizador);
        if (tarjeta.dataset.peticionCarrito !== idPeticion) return;
        delete tarjeta.dataset.anadiendo;
        if (botonActivo) {
          if (botonActivo.dataset.esperaOpciones === 'true') {
            actualizarBotonVariante(tarjeta);
          } else {
            const disponible = botonActivo.dataset.disponible !== 'false';
            botonActivo.disabled = !disponible;
            botonActivo.textContent = disponible ? textoBoton : textoAgotado;
          }
        }
      }
    };

    const actualizarBotonVariante = (tarjeta) => {
      const boton = tarjeta.querySelector('[data-tarjeta-producto-anadir]');
      if (!boton || boton.dataset.esperaOpciones !== 'true') return;

      const variantes = leerVariantes(tarjeta);
      const seleccion = seleccionDesdeTarjeta(tarjeta);

      const grupos = tarjeta.querySelectorAll('[data-tarjeta-producto-opciones] fieldset').length;
      const elegidas = Object.keys(seleccion).length;
      if (elegidas < grupos) {
        boton.disabled = true;
        boton.dataset.disponible = 'false';
        boton.textContent = tarjeta.dataset.textoElegirOpciones || 'Elegir opciones';
        return;
      }

      const variante = resolverVariante(variantes, seleccion);
      const feedback = tarjeta.querySelector('[data-tarjeta-producto-feedback]');
      if (!variante) {
        boton.disabled = true;
        boton.dataset.disponible = 'false';
        boton.dataset.varianteId = '';
        boton.textContent = tarjeta.dataset.textoCombinacionInvalida || 'Combinación no disponible';
        if (feedback) {
          feedback.hidden = false;
          feedback.classList.add('tarjeta-producto__feedback--error');
          feedback.textContent = tarjeta.dataset.textoCombinacionInvalida || 'Combinación no disponible';
        }
        return;
      }

      if (!variante.available) {
        boton.disabled = true;
        boton.dataset.disponible = 'false';
        boton.dataset.varianteId = '';
        boton.textContent = tarjeta.dataset.textoAgotado || 'Agotado';
        if (feedback) feedback.hidden = true;
        return;
      }
      if (feedback) {
        feedback.hidden = true;
        feedback.classList.remove('tarjeta-producto__feedback--error');
      }

      boton.disabled = false;
      boton.dataset.disponible = 'true';
      boton.dataset.varianteId = String(variante.id);
      boton.textContent = tarjeta.dataset.textoBotonAnadir || 'Añadir al carrito';
    };

    document.addEventListener('click', (evento) => {
      const opcion = evento.target.closest('[data-tarjeta-producto-opcion]');
      if (opcion) {
        evento.preventDefault();
        const tarjeta = opcion.closest('[data-tarjeta-producto]');
        if (!tarjeta) return;
        const posicion = opcion.dataset.posicion;
        tarjeta.querySelectorAll(`[data-tarjeta-producto-opcion][data-posicion="${posicion}"]`).forEach((btn) => {
          btn.setAttribute('aria-pressed', btn === opcion ? 'true' : 'false');
        });
        sincronizarVistaVariante(tarjeta);
        actualizarBotonVariante(tarjeta);
        return;
      }

      const botonAnadir = evento.target.closest('[data-tarjeta-producto-anadir]');
      if (botonAnadir) {
        evento.preventDefault();
        const varianteId = botonAnadir.dataset.varianteId;
        if (!varianteId || botonAnadir.disabled) return;
        const tarjeta = botonAnadir.closest('[data-tarjeta-producto]');
        if (!tarjeta) return;
        anadirVariante(tarjeta, varianteId, botonAnadir);
        return;
      }

      const botonTalla = evento.target.closest('[data-tarjeta-producto-talla]');
      if (!botonTalla) return;

      evento.preventDefault();
      evento.stopPropagation();
      if (botonTalla.dataset.disponible !== 'true') return;

      const tarjeta = botonTalla.closest('[data-tarjeta-producto]');
      if (!tarjeta) return;
      anadirVariante(tarjeta, botonTalla.dataset.varianteId, null);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
